import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { roundHelper } from 'lib/helpers/round.helper.class.js';
import { CoreComponent } from '../core/core.component.js';
import { FlexRowAlign } from '../flex/index.js';
import { TagType } from '../tag/index.js';

type Box = {
	readonly title: string;
	readonly value: string;
	readonly className: string;
	readonly tagType: TagType;
	readonly percentageOfTotal: number | undefined;
};

type NutritionBoxesDesign = 'tags' | 'tagsAlt' | 'alt';

@Component({
	selector: 'lib-nutrition-boxes',
	templateUrl: './nutrition-boxes.component.html',
	styleUrls: ['./nutrition-boxes.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class NutritionBoxesComponent extends CoreComponent {
	public readonly proteins = input.required<number>();
	public readonly kcal = input.required<number>();
	public readonly carbs = input.required<number>();
	public readonly fats = input.required<number>();
	public readonly showPercentageOfTotal = input<boolean>(true);
	public readonly design = input<NutritionBoxesDesign>('tags');
	public readonly nutritionRowAlign = input<FlexRowAlign>('center');

	public readonly boxes = computed<readonly Box[]>(() => {
		const totalGrams = this.proteins() + this.carbs() + this.fats();

		return [
			{
				title: 'Proteins',
				value: `${this.proteins().toString()}g`,
				className: `ui-proteins`,
				tagType: 'proteins',
				percentageOfTotal: this.roundTo((100 * this.proteins()) / totalGrams)
			},
			{
				title: 'Carbs',
				value: `${this.carbs().toString()}g`,
				className: `ui-carbs`,
				tagType: 'carbs',
				percentageOfTotal: this.roundTo((100 * this.carbs()) / totalGrams)
			},
			{
				title: 'Fats',
				value: `${this.fats().toString()}g`,
				className: `ui-fats`,
				tagType: 'fats',
				percentageOfTotal: this.roundTo((100 * this.fats()) / totalGrams)
			},
			{
				title: 'Kcal',
				value: `${this.kcal().toString()}${this.design() === 'tagsAlt' ? '' : ' kcal'}`,
				className: `ui-kcal`,
				tagType: 'kcal',
				percentageOfTotal: undefined
			}
		];
	});

	constructor() {
		super();
	}

	private roundTo(value: number): number {
		return roundHelper.roundTo(value, 1);
	}
}
